import React from 'react'
import { BLOCKS, MARKS } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

import {
  EndBannerSection,
  EndBannerContainer,
  EndItemImage,
  EndBannerText,
  EndDetailsContainer,
  EndBannerLink,
  EndBannerButton
} from './styles'

const options = {
  renderMark: {
    [MARKS.BOLD]: text => <Bold>{text}</Bold>,
  },
  renderNode: {
    [BLOCKS.EMBEDDED_ASSET]: node => {
      const { file, description } = node.data.target.fields
      return <EndItemImage src={file['en-AU'].url} alt={description['en-AU']} />
    },
    [BLOCKS.PARAGRAPH]: (node, children) => (
      <EndBannerText>{children}</EndBannerText>
    ),
  },
}

const EndBanner = ({ lastBannerSources, lastBanner, checkedLocale }) => {

  const {
    description,
    mainActionText,
    mainActionUrl
  } = lastBanner

  return (
    <EndBannerSection sources={lastBannerSources}>
      <EndBannerContainer sources={lastBannerSources}>
        <EndDetailsContainer>
          {documentToReactComponents(description.json, options)}
          {mainActionUrl != undefined || mainActionUrl != null ? (
            <EndBannerButton>
              <EndBannerLink to={`/${mainActionUrl}`}>
                {mainActionText}
              </EndBannerLink>
            </EndBannerButton>
          ) : (
            ''
          )}
        </EndDetailsContainer>
      </EndBannerContainer>
    </EndBannerSection>
  )
}

export default EndBanner
